<template>
    <b-container fluid>
      <b-row>
        <b-col lg="12">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Web3 Wallet</h4>
            </template>
            <template v-slot:default>
              <div v-if="loading"><el-skeleton :rows="5" animated /></div>
              <div v-if="!loading && walletDocument.address">
                <el-row :gutter="16">
                  <el-col :span="12">
                    <div class="statistic-card">
                      <el-statistic :value="walletDocument.address">
                        <template #title>
                          <div style="display: inline-flex; align-items: center">
                            <span>Wallet address</span>
                            <el-tooltip
                              effect="dark"
                              content="Your web3 wallet address."
                              placement="top"
                            >
                              <el-icon style="margin-left: 4px" :size="12">
                                <Warning />
                              </el-icon>
                            </el-tooltip>
                          </div>
                        </template>
                      </el-statistic>
                    </div>
                  </el-col>
                  <el-col :span="12" v-if="texavieCoinBalance">
                    <div class="statistic-card">
                      <el-statistic
                        :value="texavieCoinBalance"
                        title="Texavie Coin Balance"
                      >
                        <template #title>
                          <div style="display: inline-flex; align-items: center">
                            <span>Texavie Coin Balance</span>
                          </div>
                        </template>
                      </el-statistic>
                    </div>
                  </el-col>
                </el-row>
                <div class="mt-2">
                    <button class="btn btn-primary" @click="toImportWallet">Import wallet</button>
                    <button class="btn btn-primary ml-2" @click="toExportWallet">Export wallet</button>
                </div>
              </div>
              <div v-if="!loading && !walletDocument.address">
                <Web3WalletSetupVue></Web3WalletSetupVue>
               </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <iq-card v-if="!loading && walletDocument.address">
            <template v-slot:headerTitle>
              <h4 class="card-title">Transaction History</h4>
            </template>
            <template v-slot:default>
                <div v-if="walletDocument.transactions">
                    <div style="overflow-x:auto">
                        <table>
                            <tr class="header">
                                <th>Date</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                            <tbody>
                                <tr class="data" v-for="transaction in transactionsForEachPage" :key="transaction">
                                        <td>{{ formatDate(transaction.timestamp) }} </td>
                                        <td>{{ transaction.type }} </td>
                                        <td>{{ transaction.name }}</td>
                                        <td>{{ transaction.value }}</td>
                                </tr>
                            </tbody>
                        </table>
                            <b-pagination :hide-goto-end-buttons="false" :per-page="perPage" limit="4"
                            v-model="currentPage" pills :total-rows="total" size="sm" align="right" class="pagination"></b-pagination>
                             <div class="page-control mb-2">
                                Per Page
                                <select v-model="perPage" class="ml-1 mr-1 pl-2 select">
                                 <option value=3>3</option>
                                  <option value=5>5</option>
                                  <option value=10>10</option>
                                  <option :value=walletDocument.transactions.length>All</option>
                                </select>
                                Showing {{ start }} to {{ end }} of {{ total }}
                             </div>
                    </div>
                </div>
                <div v-else>
                    <el-empty description="No transaction history." />
                </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row v-if="!loading && walletDocument.address">
        <b-col lg="12">
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">Shop coins</h4>
            </template>
            <template v-slot:default>
              <PurchaseableSessions productType="coins"></PurchaseableSessions>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
  </template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import getDocument from '../../services/getDocument'
import firebase from '../../../firebase'
import PurchaseableSessions from '../../components/Purchaseables.vue'
import web3Service from '../../services/web3/web3Service'
import { onMounted, ref, watch, watchEffect, computed } from 'vue'
import Web3WalletSetupVue from '../../components/Web3WalletSetup.vue'
import { useRouter } from 'vue-router'

const body = document.getElementsByTagName('body')

export default {
  name: 'ShopSessions',
  components: { IqCard, PurchaseableSessions, Web3WalletSetupVue },
  setup () {
    const firebasePatient = firebase.firebaseAuth.currentUser
    const { document: walletDocument, loading } = getDocument('web3Wallets', firebasePatient.uid)
    const { getBalance } = web3Service()
    const texavieCoinBalance = ref(null)
    const router = useRouter()
    const formatDate = (timestamp) => {
      const date = timestamp.toDate()
      const options = { month: 'long', day: 'numeric', year: 'numeric' }
      return date.toLocaleDateString('en-US', options)
    }

    watch(walletDocument, async () => {
      if (walletDocument.value && walletDocument.value.address) {
        texavieCoinBalance.value = `${await getBalance(walletDocument.value.address)} TX`
      }
    })

    onMounted(() => {
      loading.value = true
    })

    const toImportWallet = () => {
      router.push({ name: 'patient.importWallet' })
    }

    const toExportWallet = () => {
      router.push({ name: 'patient.exportWallet', params: { walletAddress: walletDocument.value.address } })
    }

    const transactionsForEachPage = ref(null)
    const total = ref(null)
    const currentPage = ref(1)
    const perPage = ref(5)

    watchEffect(() => {
      if (walletDocument.value && walletDocument.value.transactions) {
        total.value = walletDocument.value.transactions.length

        const start = Number((currentPage.value - 1)) * Number(perPage.value)
        const end = start + Number(perPage.value)
        transactionsForEachPage.value = walletDocument.value.transactions.slice(start, end)
      }
    })

    const start = computed(() => {
      return Number((currentPage.value - 1)) * Number(perPage.value) + 1
    })

    const end = computed(() => {
      return Number(start.value) + Number(perPage.value) - 1
    })

    watch(perPage, () => {
      currentPage.value = 1
    })

    return {
      walletDocument,
      texavieCoinBalance,
      loading,
      toImportWallet,
      toExportWallet,
      formatDate,
      transactionsForEachPage,
      start,
      end,
      total,
      perPage,
      currentPage
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

  <style>
  .el-statistic__number {
    overflow-wrap: break-word;
    font-size: 13px;
  }

  .el-statistic__head {
    font-size: 14px !important;
  }

  .btn-icon {
    font-size: 18px;
    color: #b583bc;
  }
  </style>

  <style scoped>
    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 1em;
    }
    .header {
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }
    .data {
        box-shadow: 0px 0px 9px 0px var(--border-color);
        margin-bottom: 20px;
    }

    td {
        padding: 15px 30px;
        margin-top: 15px;
    }

    td div {
        float: right;
        font-size: 15px;
    }

    th {
        padding-left: 30px;
    }

    .pagination {
      padding: 10px 15px;
      display: inline-flex;
    }

    .page-control {
      margin: 10px 5px 0 15px;
      padding: 0 10px;
      display: inline-flex;
      float: right;
    }

    span {
      color: var(--text-color);
    }
  </style>
